import axios from "axios";
import { Constants } from "../utils/constants";

const guestApi = axios.create({
  baseURL: Constants.URL.base,
  headers: {
    "Content-Type": "application/json",
  },
});

export { guestApi };